export const resources = {
  CapsuleInputAdding: '',
  CapsuleInputAdd: '',
  InsightsShowingTimeline: ''
};
